import { avatarDefault, profileBackground } from '@/assets/images';
import { Divider, Stack } from '@/components/layout';
import { Image } from '@/components/ui';
import Text from '@/components/ui/text/text';
import { useAcademyQuery, useCoachQuery } from '@/features/home/queries';
import { createStyles, useScaling } from '@/hooks/use-scaling';
import { useEnvUrls } from '@/libs/config';
import { useSessionStore } from '@/stores/session-store';
import { colors } from '@/theme/colors';
import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useShallow } from 'zustand/react/shallow';

// Top
export function DetailCoachTop() {
  const styles = useStyles();
  const { scale, isTablet } = useScaling();
  const uid = useSessionStore(useShallow(state => state.user?.uid));
  const { data: coach } = useCoachQuery(uid);
  const { data: academy } = useAcademyQuery(coach?.academy_id);

  const avatarSize = scale(100);
  const { pictureUrl: pictureUrlBase } = useEnvUrls();
  const avatarSource = useMemo(() => {
    const pictureUrl = pictureUrlBase?.trim();
    const uri =
      pictureUrl && coach?.id
        ? `${pictureUrl}${coach.id}.jpg?alt=media&updated_at=${coach.updated_at}`
        : undefined;
    if (!uri) return undefined;
    return { uri };
  }, [coach?.id, coach?.updated_at, pictureUrlBase]);

  return (
    <Stack backgroundColor="white">
      <Image source={profileBackground} width={'100%'} height={scale(132)} resizeMode="cover" />

      <Stack style={styles.avatarWrap}>
        <Image
          source={avatarSource ? avatarSource : avatarDefault}
          width={avatarSize}
          height={avatarSize}
          circular
          defaultSource={avatarDefault}
          resizeMode="cover"
        />
      </Stack>

      <Stack align="center" style={styles.coachNameBlock} zIndex={999} backgroundColor="white">
        <Text
          fontWeight={'800'}
          variant="Font Montserrat/Body/Body 2 Bold 16px"
          style={styles.coachName}>
          {coach?.firstname ?? ''} {coach?.lastname ?? ''}
        </Text>
        <Stack direction="row" align="center" gap={scale(12)} style={styles.metaRow}>
          <Text
            variant={
              isTablet ? 'Font Inter/Subtitle/Regular 14px' : 'Font Inter/Subtitle/Regular 12px'
            }
            style={styles.coachAcademyText}>
            {academy?.name ?? ''}
          </Text>
        </Stack>
      </Stack>
      <Divider thickness={isTablet ? 1 : StyleSheet.hairlineWidth} />
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  // Top
  avatarWrap: {
    marginTop: scale(-72),
    alignSelf: 'center',
    borderRadius: 999,
    borderWidth: 2,
    borderColor: 'white',
    overflow: 'hidden',
    backgroundColor: 'white',
  },
  coachNameBlock: {
    paddingTop: scale(12),
    paddingHorizontal: scale(16),
  },
  coachName: {
    color: colors.Blue,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  metaRow: {
    marginTop: scale(4),
    marginBottom: scale(12),
  },
  coachAcademyText: {
    color: colors['10'],
  },
}));
